const API_POLICY_FIELDS = ['translations.title', 'translations.policy_text'];
export { API_POLICY_FIELDS };
